import React from "react";
import { Grid, TextField } from "@mui/material";

const BatchInfoSection = ({ form, updateField }) => {
  return (
    <>
      <Grid item xs={6}>
        <TextField
          type="number"
          label="Batch Size"
          fullWidth
          value={form.batchSize}
          onChange={(e) => updateField("batchSize", e.target.value)}
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          label="Yield Notes"
          fullWidth
          value={form.yieldNotes}
          onChange={(e) => updateField("yieldNotes", e.target.value)}
        />
      </Grid>
    </>
  );
};

export default BatchInfoSection;
